export default {
  // =========================================================================
  // HOLIDAY TAX & TOURISM IMPACT
  // =========================================================================
  holiday_tax_vote: {
    type: "likert",
    category: "business",
    label: "Impact of a tourist tax on voting",
    fulltext: "Thinking about the next General Election… If your MP had voted for this new tax on overnight stays, would you be more or less likely to vote for them?",
    client: ["Hilton", "Haven", "Butlin's", "UKHospitality", "stack-data-strategy"],
    keys: [
      "holiday_tax_more_likely_pred",
      "holiday_tax_less_likely_pred",
      "holiday_tax_no_diff_pred",
      "holiday_tax_dk_pred"
    ],
    labels: {
      "holiday_tax_more_likely_pred": "It would make me more likely to vote for them",
      "holiday_tax_less_likely_pred": "It would make me less likely to vote for them",
      "holiday_tax_no_diff_pred":     "It would make no difference",
      "holiday_tax_dk_pred":          "Don't know"
    },
    colors: {
      "holiday_tax_more_likely_pred": "#2E7D32",
      "holiday_tax_no_diff_pred":     "#6B7280",
      "holiday_tax_less_likely_pred": "#C62828",
      "holiday_tax_dk_pred":          "#B0B8C4",
    },
    polarity: {
      pos: ["holiday_tax_more_likely_pred"],
      neu: "holiday_tax_no_diff_pred",
      neg: ["holiday_tax_less_likely_pred"],
      dk:  "holiday_tax_dk_pred",
    },
    schema: "single",
  },

  holiday_tax_support: {
    type: "likert",
    label: "Support for a tourist tax",
    category: "business",
    fulltext: "The Government is considering giving local authorities in England the power to introduce a new tax on overnight stays in hotels, holiday parks, guesthouses and other paid-for accommodation including campsites and self-catering accommodation. Under current proposals, this could cost as much as £2 per person per night, adding £100 to a two-week holiday for a family of four. The Government says this money could then be used to support regional economic growth and other local priorities. Do you support or oppose this new tax?",
    client: ["Hilton", "Haven", "Butlin's", "UKHospitality", "stack-data-strategy"],
    keys: [
      "holiday_tax_supp_strong_pred",
      "holiday_tax_supp_some_pred",
      "holiday_tax_supp_neither_pred",
      "holiday_tax_supp_some_opp_pred",
      "holiday_tax_supp_strong_opp_pred",
      "holiday_tax_supp_dk_pred",
    ],
    labels: {
      "holiday_tax_supp_strong_pred":    "Strongly support",
      "holiday_tax_supp_some_pred":      "Somewhat support",
      "holiday_tax_supp_neither_pred":   "Neither support nor oppose",
      "holiday_tax_supp_some_opp_pred":  "Somewhat oppose",
      "holiday_tax_supp_strong_opp_pred":"Strongly oppose",
      "holiday_tax_supp_dk_pred":        "Don't know"
    },
    colors: {
      "holiday_tax_supp_strong_pred":     "#2E7D32",
      "holiday_tax_supp_some_pred":       "#66BB6A",
      "holiday_tax_supp_neither_pred":    "#6B7280",
      "holiday_tax_supp_some_opp_pred":   "#EF5350",
      "holiday_tax_supp_strong_opp_pred": "#C62828",
      "holiday_tax_supp_dk_pred":         "#B0B8C4",
    },
    polarity: {
      pos: ["holiday_tax_supp_strong_pred","holiday_tax_supp_some_pred"],
      neu: "holiday_tax_supp_neither_pred",
      neg: ["holiday_tax_supp_some_opp_pred","holiday_tax_supp_strong_opp_pred"],
      dk:  "holiday_tax_supp_dk_pred",
    },
    schema: "single",
  },

  decline_pride: {
    type: "likert",
    label: "Impact on local pride",
    category: "business",
    fulltext: "If there was a decline in the number of people visiting the area you live in, would that make you feel less proud of your area?",
    client: ["Hilton", "Haven", "Butlin's", "UKHospitality", "stack-data-strategy"],
    keys: [
      "decline_pride_yes_pred",
      "decline_pride_no_pred",
      "decline_pride_dk_pred"
    ],
    labels: {
      "decline_pride_yes_pred": "Yes",
      "decline_pride_no_pred":  "No",
      "decline_pride_dk_pred":  "Don't know"
    },
    polarity: {
      pos: ["decline_pride_yes_pred"],
      neg: ["decline_pride_no_pred"],
      dk:  "decline_pride_dk_pred",
    },
    schema: "single",
  },

  tourist_tax_concerns: {
    type: "categorical",
    label: "Concerns around a tourist tax",
    category: "business",
    fulltext: "If there was a decline in the number of people visiting the area you live in, which - if any - of the following would concern you…? Please select all that apply.",
    client: ["Hilton", "Haven", "Butlin's", "UKHospitality", "stack-data-strategy"],
    keys: [
      "decline_biz_pred",
      "decline_jobs_pred",
      "decline_invest_pred",
      "decline_unemp_pred",
      "decline_general_pred",
      "decline_none_pred",
    ],
    labels: {
      "decline_biz_pred":     "That local businesses would have to close",
      "decline_jobs_pred":    "That there would be fewer jobs for local young people",
      "decline_invest_pred":  "That there would be less investment in the local area",
      "decline_unemp_pred":   "That unemployment in general would increase locally",
      "decline_general_pred": "That there would be general decline locally",
      "decline_none_pred":    "None of these"
    },
    colors: {
      "decline_biz_pred":     "#D32F2F",
      "decline_jobs_pred":    "#1976D2",
      "decline_invest_pred":  "#00897B",
      "decline_unemp_pred":   "#F57C00",
      "decline_general_pred": "#7B1FA2",
      "decline_none_pred":    "#546E7A"
    },
    schema: "single",
  },

  tourist_tax_impact_travel: {
    type: "categorical",
    label: "Impact of a tourist tax on travel",
    category: "business",
    fulltext: "If the cost of an overnight stay in England increased, would it make you LESS likely to do any of the following? Please select all that apply. ",
    client: ["Hilton", "Haven", "Butlin's", "UKHospitality", "stack-data-strategy"],
    keys: [
      "act_concert_pred",
      "act_stag_hen_pred",
      "act_sport_pred",
      "act_family_pred",
      "act_museums_pred",
      "act_wedding_pred",
      "act_none_pred",
    ],
    labels: {
      "act_concert_pred":  "Go to a concert, gig or festival",
      "act_stag_hen_pred": "Go on a stag or hen do",
      "act_sport_pred":    "Go to football or other live sport",
      "act_family_pred":   "Visit family and friends",
      "act_museums_pred":  "Visit museums and galleries",
      "act_wedding_pred":  "Attend a wedding or special event",
      "act_none_pred":     "None of these"
    },
    colors: {
      "act_concert_pred":  "#1565C0",
      "act_stag_hen_pred": "#00838F",
      "act_sport_pred":    "#7B1FA2",
      "act_family_pred":   "#FB8C00",
      "act_museums_pred":  "#2E7D32",
      "act_wedding_pred":  "#C62828",
      "act_none_pred":     "#546E7A"
    },
    schema: "single",
  },
};
